import {
  ADD_NOTIFICATION,
  SET_NOTIFICATIONS,
  SET_NOTIFICATION_BANNER,
  SET_NOTIFICATION_USER_READS,
  ADD_NOTIFICATION_USER_READ,
  UPDATE_MARK_READ_NOTIFICATIONS,
  UPDATE_PUSH_NOTIFICATION_USERACCESS,
  REFRESH_NOTIFICATION,
  FETCH_NOTIFICATION,
  FINISH_GET_NOTIFICATIONS,
  GET_NOTIFICATIONS,
  NOTIFICATIONS_PAGE_READ
} from "./types";

const initialState = {
  push: [],
  banner: null,
  users: [],
  limit: 30,
  total: 0,
  notificationPage: [],
  refresh: true,
  loadMore: true,
  initialize: false,
  isRequesting: false,
  countUnread:0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NOTIFICATION:
      let unread = action.payload?.unread ?? state.countUnread;
      let newNotification = [action.payload, ...state.push];
      const uniqueNotificaiton = Array.from(new Set(newNotification.map(a => a.id))) // to avoid duplicate in after pusher from broadcasting
        .map(id => {
          return newNotification.find(a => a.id === id)
        });
      // let countNew = uniqueNotificaiton.filter(item => (item?.isNew || false) === true).length;
      return {
        ...state,
        push: uniqueNotificaiton,
        countUnread:unread
      };

    case SET_NOTIFICATIONS:
      return {
        ...state,
        push: action.payload.notifications,
        countUnread:action.payload?.unread || state.countUnread
      };

    case SET_NOTIFICATION_BANNER:
      return {
        ...state,
        banner: action.payload,
      };

    case SET_NOTIFICATION_USER_READS:
      return {
        ...state,
        users: action.payload
          .filter((notif) => notif.status === "read")
          .map((notif) => notif.notification_id),
      };

    case ADD_NOTIFICATION_USER_READ:
      return {
        ...state,
        users: [action.payload, ...state.users],
      };

    case UPDATE_MARK_READ_NOTIFICATIONS:
      let newPush = [];
      let readAll = [];

      state.push.forEach((un) => {
        newPush.push({
          ...un,
          is_read: true,
        });
      });

      state.notificationPage.forEach((un) => {
        readAll.push({
          ...un,
          is_read: true,
        });
      });

      return {
        ...state,
        push: newPush,
        notificationPage: readAll,
        countUnread:0
      };

    case UPDATE_PUSH_NOTIFICATION_USERACCESS:
      let newPushNotifications = state.push;

      state.push.forEach((un, index) => {
        if (un.id === action.payload.id) {
          newPushNotifications[index] = action.payload;
        }
      });

      return {
        ...state,
        push: newPushNotifications,
      };

      case REFRESH_NOTIFICATION:
        return{
          ...state,
          refresh: false,
          loadMore: true,
          initialize: true,
          notificationPage:[]
        }
      case FETCH_NOTIFICATION:
        return {
          ...state,
          notificationPage: [...state.notificationPage, ...action.payload.data],
          total: action.payload.total,
          countUnread: action.payload?.unread
        }

      case FINISH_GET_NOTIFICATIONS:
        return {
          ...state,
          isRequesting: true,
          loadMore: action.payload.loadMore,
        };

      case GET_NOTIFICATIONS:
          return {
            ...state,
            isRequesting: true,
          };
      case NOTIFICATIONS_PAGE_READ:
        console.log(action.payload.data)
          return {
            ...state,
            notificationPage: action.payload.data,
          };


    default:
      return state;
  }
};

export default reducer;
